import { VApp } from 'vuetify/lib/components/VApp';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VApp, [_c('Alerts'), _c('Loader'), _c('AppLayout', [_c('RouterView')], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };